/* =============================================================
   Sweet Smiling Soul — Cart Upsell add-on (Nov 2026)
   Loaded right AFTER cart-upsell.js. Changes three things:

   1) The Christmas Storybook is an ANCHOR ONLY. Having it in the cart
      unlocks the "add a pattern, 50% off" offer for the other books,
      but it is never offered at 50% itself (it has its own XMAS10
      code). In Shopify it sits in the BUY list of the upsell codes,
      not the GET list.
   2) With only the Christmas book in the cart, all three books can be
      offered, so three ticks use ADDPATTERN50OFFX3.
   3) Codes the customer added themselves (e.g. XMAS10) are kept when
      the upsell codes are re-synced. Only our own upsell codes are
      cleared and re-applied.

   4) Nov 2026: the code follows what is really in the cart. If the
      full-price anchor is removed, one remaining add-on becomes the
      full-price "buy" item, so the code steps down by one (two add-ons
      left -> ADDPATTERN50OFF). Without this the x2 code stayed on with
      nothing to "buy", and no 50% applied at all.
   5) Nov 2026: shorter pattern descriptions in the upsell rows.
   6) Nov 2026: the Christmas Storybook is now a full upsell pattern.
      It is offered at 50% off as the FIRST row whenever another pattern
      (or the bundle) is in the cart, with a NEW / Special Christmas
      offer ribbon (the row itself looks like the others). It is in the
      BUY and GET lists of ADDPATTERN50OFF, ...X2 and ...X3. When it is
      the first item in the cart, it still unlocks 50% off the others.

   To add another anchor-only product, add its handle below and add
   the product to the BUY list of ADDPATTERN50OFF, ...X2 and ...X3.
   ============================================================= */
(function () {
  if (typeof CartUpsell === 'undefined') return;
  var P = CartUpsell.prototype;

  /* none now: the Christmas Storybook is a normal upsell pattern (6) */
  P.ANCHOR_ONLY_HANDLES = [];

  var XMAS = {
    key: 'christmas',
    inBundle: false,
    name: '🎄 Christmas Storybook',
    handle: 'diy-fabric-doll-and-christmas-storybook-sewing-pattern-beginner-friendly-digital',
    blurb: 'A foldable fabric Christmas book with 7 festive scenes: house and letter to Santa, Christmas tree, presents, Santa and sleigh, reindeer, bedroom and fireplace + boy and girl doll.'
  };

  /* add the Christmas row FIRST, once per page (PATTERNS lives on the
     instance, so this runs the first time any pattern lookup happens) */
  P.ensureXmas = function () {
    if (this._sssXmas || !this.PATTERNS) return;
    this._sssXmas = true;
    var has = this.PATTERNS.some(function (p) { return p.key === XMAS.key; });
    if (!has) this.PATTERNS.unshift(XMAS);
  };
  ['patternByKey', 'patternByHandle', 'patternByHandleKey', 'offersFor', 'warmProducts'].forEach(function (name) {
    var base = P[name];
    if (typeof base !== 'function') return;
    P[name] = function () { this.ensureXmas(); return base.apply(this, arguments); };
  });
  P.TRIPLE_CODE = 'ADDPATTERN50OFFX3';
  P.UPSELL_CODES = ['ADDPATTERN50OFF', 'ADDPATTERN50OFFX2', 'ADDPATTERN50OFFX3'];

  var basePatternsState = P.patternsState;
  P.patternsState = function (cart) {
    this.ensureXmas();
    var state = basePatternsState.call(this, cart);
    var handles = (cart.items || []).map(function (i) { return i.handle; });
    state.anchorOnlyInCart = this.ANCHOR_ONLY_HANDLES.some(function (h) { return handles.indexOf(h) !== -1; });
    return state;
  };

  P.hasAnchor = function (state) {
    return state.bundleInCart || state.anchorOnlyInCart || state.inCart.length >= 1;
  };

  P.codesForCommitted = function (committed) {
    if (committed.length >= 3) return [this.TRIPLE_CODE];
    if (committed.length === 2) return [this.DOUBLE_CODE];
    if (committed.length === 1) return [this.SINGLE_CODE];
    return [];
  };

  /* products that can be the BXGY "buy" item (same as the codes' BUY list) */
  P.BUY_HANDLES = [
    'doll-fabric-dollhouse-sewing-pattern-beginner-pdf-pattern-diy-dollhouse-storybook-scrap-fabric-project-handmade-doll-pattern',
    'diy-fabric-doll-and-adventure-book-sewing-pattern-beginner-friendly-pdf-pattern',
    'bundle-diy-fabric-doll-and-adventure-book-sewing-pattern-beginner-friendly-pdf-pattern',
    'diy-fabric-doll-and-playtime-storybook-sewing-pattern-beginner-friendly-digital',
    'diy-fabric-doll-and-christmas-storybook-sewing-pattern-beginner-friendly-digital'
  ];

  /* the code that matches the cart: one step down when no full-price
     anchor is left, because one add-on then has to be the "buy" item */
  P.codesForCart = function (cart, committed) {
    var self = this;
    var hasFullPriceAnchor = (cart.items || []).some(function (i) {
      return !(i.properties && i.properties._addon) && self.BUY_HANDLES.indexOf(i.handle) !== -1;
    });
    var n = committed.length - (hasFullPriceAnchor ? 0 : 1);
    return this.codesForCommitted(n > 0 ? committed.slice(0, n) : []);
  };

  P.addonCodes = function (cart) {
    var self = this;
    var handles = (cart.items || []).map(function (i) { return i.handle; });
    var committed = this.getAddons()
      .map(function (k) { return self.patternByKey(k); })
      .filter(function (p) { return p && handles.indexOf(p.handle) !== -1; });
    return this.codesForCart(cart, committed);
  };

  /* Same as the original, except customer-entered codes are kept */
  P.syncDiscountCodes = function () {
    var self = this;
    return this.getCart().then(function (cart) {
      var handles = (cart.items || []).map(function (i) { return i.handle; });
      var committed = self.getAddons()
        .map(function (k) { return self.patternByKey(k); })
        .filter(function (p) { return p && handles.indexOf(p.handle) !== -1; });

      self.setAddons(committed.map(function (p) { return p.key; }));

      var codes = self.codesForCart(cart, committed);
      var keep = (cart.discount_codes || [])
        .map(function (d) { return d && d.code ? String(d.code) : ''; })
        .filter(function (c) { return c && self.UPSELL_CODES.indexOf(c.toUpperCase()) === -1; });
      var allCodes = keep.concat(codes);

      var channels = self.getChannels();
      var summary = committed.map(function (p) {
        return p.key + ':' + (channels[p.key] || 'notification');
      }).join(',');
      var anchors = (cart.items || [])
        .filter(function (i) { return !(i.properties && i.properties._addon); })
        .map(function (i) { return i.handle; })
        .join(',');

      self.setAppliedSig(codes.slice().sort().join(','));

      var attributes = {
        pattern_upsell: summary,
        pattern_upsell_count: committed.length ? String(committed.length) : '',
        pattern_upsell_anchor: committed.length ? anchors : ''
      };

      return self.postCart({ discount: '' }).then(function () {
        return self.postCart({
          discount: allCodes.length ? allCodes.join(',') : '',
          attributes: attributes
        });
      }).then(function () { return cart; });
    });
  };

  /* ---- 5) pattern descriptions in the upsell rows (text only) ---- */
  var BLURBS = {
    dollhouse: 'A foldable fabric dollhouse book with 6 rooms to decorate: bedroom, bathroom, living room, dining room, hobby room and wardrobe + boy and girl doll.',
    adventure: 'A foldable fabric adventure book with 7 outdoor scenes to explore: tent, sunny hills, beach, treehouse, picnic, hammock and swing + boy and girl doll.',
    playtime: 'A foldable fabric playtime book with 8 playful scenes: bicycle, costume box, tea party, cosy corner, slippery slide, paddling pool, painting station and music room + boy and girl doll.'
  };
  var CROWN_ROW = 'A foldable fabric playtime book with 8 playful scenes, including a costume box with a little crown, cape and fairy wings for the doll to wear + boy and girl doll.';

  P.applyBlurbs = function () {
    if (this._sssBlurbs) return;
    this._sssBlurbs = true;
    (this.PATTERNS || []).forEach(function (p) { if (BLURBS[p.key]) p.blurb = BLURBS[p.key]; });
    var c = this.ENTRY_COPY || {};
    if (c.crown_party) c.crown_party.rowBlurb = CROWN_ROW;
    if (c.crown_xmas) c.crown_xmas.rowBlurb = CROWN_ROW;
    if (c.cushion) c.cushion.rowBlurb = BLURBS.playtime;
  };

  var baseUpsellMarkup = P.upsellMarkup;
  P.upsellMarkup = function (products, context, bundleInCart) {
    this.ensureXmas();
    this.applyBlurbs();
    this.injectXmasStyles();
    var html = baseUpsellMarkup.apply(this, arguments);
    /* the bundle heading named only Playtime; Christmas is offered too now */
    if (bundleInCart && products && products.length > 1) {
      html = html.replace('Complete the collection: add the Playtime Storybook for 50% off', 'Complete the collection &amp; save 50%');
    }
    return html;
  };

  /* ---- 6) highlight the Christmas row ---- */
  var baseBumpRow = P.bumpRow;
  P.bumpRow = function (opts) {
    var html = baseBumpRow.apply(this, arguments);
    if (opts && opts.key === XMAS.key && opts.mode !== 'entry') {
      html = html
        .replace('class="sss-bump', 'class="sss-bump sss-bump--xmas')
        .replace('<span class="sss-bump__title">', '<span class="sss-bump__ribbon">🎄 NEW · Special Christmas offer</span><span class="sss-bump__title">');
    }
    return html;
  };

  P.injectXmasStyles = function () {
    if (document.getElementById('sss-xmas-styles')) return;
    var st = document.createElement('style');
    st.id = 'sss-xmas-styles';
    st.textContent =
      '.sss-bump__ribbon{display:inline-block;align-self:flex-start;background:#9C3F33;color:#fff;font-size:1.05rem;font-weight:700;letter-spacing:.03em;line-height:1.2;padding:.35rem .8rem;border-radius:999px;margin:0 0 .5rem;}';
    (document.head || document.body).appendChild(st);
  };
  var baseEntryMarkup = P.entryMarkup;
  P.entryMarkup = function () { this.applyBlurbs(); return baseEntryMarkup.apply(this, arguments); };
})();
